"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLegacyLanguageCookieValue = void 0;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _getLegacyCookieName = require("./getLegacyCookieName");
/**
 * Gets new language cookie value
 */
const getLegacyLanguageCookieValue = tenant => _jsCookie.default.get((0, _getLegacyCookieName.getLegacyCookieName)(tenant));
exports.getLegacyLanguageCookieValue = getLegacyLanguageCookieValue;